export default "__VITE_ASSET__2D1DFCNu__"